/**
 * EndPoints.js
 *
 * Copyright (c) apploft. GmbH
 */

import React from 'react';
import {colorMatching, stringMatching} from 'apploft-cloud-forms';
import {select} from './EndPointBrowserState';

function EndPointButton({section, onClick, strings, selected, colors}) {
  const props = {
    style: {
      color: !selected
        ? colorMatching(colors, 'primary')
        : colorMatching(colors, 'secondary'),
      fontWeight: !selected ? 400 : 700,
    },
    title: stringMatching(strings, section.description),
    onClick: e => onClick(section, e),
  };

  return <button {...props}>{stringMatching(strings, section.name)}</button>;
}

function EndPoints({title, sections, section, dispatch, strings, colors}) {
  const onClick = (s, e) => {
    dispatch({type: select, section: s});
  };

  return (
    <nav>
      <ul>
        <h1>{stringMatching(strings, title)}</h1>
        {sections.map(s => {
          const {name} = s;
          const isSelected = name === section.name;

          return (
            <li key={s.name}>
              <EndPointButton
                section={s}
                selected={isSelected}
                onClick={e => onClick(s, e)}
                strings={strings}
                colors={colors}
              />
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default EndPoints;
